import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { loadSlides } from '../actions'
import HomeSlideshow from '../components/home-page/HomeSlideshow'

class Slideshow extends React.Component {
	loadNextSlide = () => {
		const { dispatch, slides, numLoaded } = this.props
		dispatch(loadSlides(slides, numLoaded))
	}

	render() {
		return(
		  <HomeSlideshow {...this.props} loadNextSlide={this.loadNextSlide} />
		)
	}
}

Slideshow.propTypes = {
  slides: PropTypes.array.isRequired,
  loaderHidden: PropTypes.bool.isRequired,
}

const mapStateToProps = state => {
  const { loaderHidden } = state.loader
  const { numLoaded } = state.slides
  return { loaderHidden, numLoaded }
}

export default connect(mapStateToProps,
	dispatch => ({ dispatch }))(Slideshow)



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/Slideshow.js